// ===========================================
// BUSTED! BLACKJACK - GAME EVENT TYPES
// ===========================================
// Event-driven architecture for blackjack game
// All game state changes are communicated via discrete events
// ===========================================
// ----- Player Game Status (State Machine) -----
export var PlayerGameStatus;
(function (PlayerGameStatus) {
    PlayerGameStatus["EMPTY"] = "empty";
    PlayerGameStatus["BETTING"] = "betting";
    PlayerGameStatus["READY"] = "ready";
    PlayerGameStatus["DEALT_IN"] = "dealt_in";
    PlayerGameStatus["MY_TURN"] = "my_turn";
    PlayerGameStatus["PREMATURE_RESOLVED"] = "premature_resolved";
    PlayerGameStatus["WAITING"] = "waiting";
    PlayerGameStatus["AWAIT_DEALER"] = "await_dealer";
    PlayerGameStatus["RESOLVED"] = "resolved";
})(PlayerGameStatus || (PlayerGameStatus = {}));
// ===========================================
// TYPE GUARDS
// ===========================================
export function isRoundEvent(event) {
    return event.category === 'round';
}
export function isBettingEvent(event) {
    return event.category === 'betting';
}
export function isDealingEvent(event) {
    return event.category === 'dealing';
}
export function isPlayerTurnEvent(event) {
    return event.category === 'player_turn';
}
export function isInsuranceEvent(event) {
    return event.category === 'insurance';
}
export function isDealerEvent(event) {
    return event.category === 'dealer';
}
export function isResolutionEvent(event) {
    return event.category === 'resolution';
}
// ===========================================
// EVENT FACTORY HELPER
// ===========================================
let globalSequenceNumber = 0;
export function createEventBase(tableId, roundId, category) {
    return {
        tableId,
        roundId,
        category,
        sequenceNumber: ++globalSequenceNumber,
        timestamp: Date.now(),
    };
}
export function resetSequenceNumber() {
    globalSequenceNumber = 0;
}
//# sourceMappingURL=game-events.js.map